import React from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { Box, Button, TextField } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

interface EndpointAgentEditProps {
  onSubmit: () => void;
  endpointNode: string;
  userAgentDnsServers?: string;
  userAgentCidrs?: string;
}
export const EndpointAgentEdit = ({
  onSubmit,
  endpointNode,
  userAgentDnsServers,
  userAgentCidrs,
}: EndpointAgentEditProps) => {
  const api = useApi();
  const [dns, setDns] = React.useState(userAgentDnsServers || '');
  const [cidrs, setCidrs] = React.useState(userAgentCidrs || '');

  const epEditPost = useMutation(api.editEndpointApiV1EditEndpointPost, {
    onSuccess() {
      toast.success('Updated Endpoint Agent Details successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    epEditPost.mutate({
      ep_id: endpointNode,
      user_agent_dns_servers: dns,
      user_agent_cidrs: cidrs,
    });
  };

  return (
    <Box pt={2}>
      <TextField
        fullWidth
        label="Endpoint ID"
        variant="outlined"
        value={endpointNode}
        sx={{ mb: 4 }}
        disabled
      />

      <TextField
        fullWidth
        label="User Agent DNS Servers"
        variant="outlined"
        value={dns}
        onChange={(e) => setDns(e.target.value)}
        helperText="Comma separated list of DNS servers"
        sx={{ mb: 4 }}
        autoFocus
      />

      <TextField
        fullWidth
        label="User Agent CIDRs"
        variant="outlined"
        value={cidrs}
        onChange={(e) => setCidrs(e.target.value)}
        helperText="Comma separated list of CIDRs"
        sx={{ mb: 4 }}
      />

      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit}>
          Save Agent Details
        </Button>
      </Box>
    </Box>
  );
};
